/** 0-预约成功，1-预约成功，2-环检完成，3-方案已确认，4-方案已确认，5-施工中，6-待支付，7-待支付，8-已完成，9-已关闭 */
export enum ServiceOrderStatus {
  /** 0-预约成功 */
  BOOKED = 0,
  /** 1-预约成功 */
  BOOKED_SUCCESS = 1,
  /** 2-环检完成 */
  INSPECTION_COMPLETE = 2,
  /** 3-方案已确认 */
  SCHEME_CONFIRMED = 3,
  /** 4-方案已确认 */
  SCHEME_CONFIRMED_SUCCESS = 4,
  /** 5-施工中 */
  CONSTRUCTION = 5,
  /** 6-待支付 */
  WAIT_PAY = 6,
  /** 7-待支付 */
  WAIT_PAY_SUCCESS = 7,
  /** 8-已完成 */
  COMPLETED = 8,
  /** 9-已关闭 */
  CLOSED = 9
}

/**0-待支付，1-已支付，2-已完成，3-退货处理中，4-已取消 */
export enum SalesOrderStatus {
  /** 0-待支付 */
  WAIT_PAY = 0,
  /** 1-已支付 */
  PAID = 1,
  /** 2-已完成 */
  COMPLETED = 2,
  /** 3-退货处理中 */
  RETURN_PROCESSING = 3,
  /** 4-已取消 */
  CANCELED = 4
}

/**显示绿色的状态 */
export const SERVICE_GREEN_STATUS = [
  ServiceOrderStatus.BOOKED,
  ServiceOrderStatus.BOOKED_SUCCESS,
  ServiceOrderStatus.INSPECTION_COMPLETE,
  ServiceOrderStatus.SCHEME_CONFIRMED,
  ServiceOrderStatus.SCHEME_CONFIRMED_SUCCESS,
  ServiceOrderStatus.CONSTRUCTION
];

export const SALES_GREEN_STATUS = [
  SalesOrderStatus.PAID,
  SalesOrderStatus.RETURN_PROCESSING
];

/**显示橙色的状态 */
export const SERVICE_ORANGE_STATUS = [
  ServiceOrderStatus.WAIT_PAY,
  ServiceOrderStatus.WAIT_PAY_SUCCESS
];

export const SALES_ORANGE_STATUS = [SalesOrderStatus.WAIT_PAY];

/**显示灰色的状态 */
export const SERVICE_GRAY_STATUS = [
  ServiceOrderStatus.COMPLETED,
  ServiceOrderStatus.CLOSED
];

export const SALES_GRAY_STATUS = [
  SalesOrderStatus.COMPLETED,
  SalesOrderStatus.CANCELED
];
